import { ONGLET_EMPLOYEUR } from '../shared'

export const OngletsCar = [ONGLET_EMPLOYEUR] as const
export type OngletsCar = (typeof OngletsCar)[number]

export const OngletsCarLibellés: Record<OngletsCar, string> = {
  Employeur: 'Employeur',
}
